import QuestionItemList, { QuestionItemListProps } from './QuestionItemList';

export type { QuestionItemListProps };
export default QuestionItemList;
